import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { RoutingRuleAction } from '../routingRule.action';

export const reloadRoutingRuleListEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    RoutingRuleAction.reload,
    RoutingRuleAction.update.done,
  ),
  mergeMap(() => {
    return [
      RoutingRuleAction.loadList.started(),
    ];
  }),
);
